// Every landing section sits inside a .fp-wrapper.
//
// The pre-React page created these wrappers imperatively after fetching the
// section fragments (`initSections()` inserted a div around each `#content >
// section`). Rendering them declaratively is the same DOM, minus the reparenting
// step. Both observers in useSectionObservers depend on this structure: the nav
// observer watches `section[id]`, the reveal observer watches `.fp-wrapper`.
export function Section({ children }) {
  return <div className="fp-wrapper">{children}</div>;
}
